import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "form-group" }
const _hoisted_2 = ["accept", "disabled"]
const _hoisted_3 = { class: "file-preview-area mt6" }
const _hoisted_4 = ["src"]
const _hoisted_5 = ["onClick"]
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "file-name" }

import {
  ref,
  watch,
} from 'vue';
import type { CandidateFile } from 'src/models';
import {
  isImageFileType,
  fileTypeIconFromFilePath,
} from 'src/lib/fileHelper';
import { MAX_SAVABLE_FILES_COUNT } from 'src/lib/commentHelper';

interface Props {
  previewFiles: CandidateFile[];
  isChangeable: boolean;
  acceptedFileTypes: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    previewFiles: {},
    isChangeable: { type: Boolean },
    acceptedFileTypes: {}
  },
  emits: ["file-upload", "remove-file"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const refUploadFile = ref<HTMLInputElement>();
const handleFileUpload = () => {
  const fileList = refUploadFile.value?.files;
  if (!fileList) return;

  emit('file-upload', fileList);
};
const removeFile = (fileId: number) => {
  emit('remove-file', fileId);
};
watch(() => props.previewFiles, () => {
  if (refUploadFile.value && props.previewFiles.length === 0) {
    refUploadFile.value.value = '';
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.isChangeable)
      ? (_openBlock(), _createElementBlock("input", {
          key: 0,
          type: "file",
          accept: __props.acceptedFileTypes,
          class: "mb6 file-input",
          ref_key: "refUploadFile",
          ref: refUploadFile,
          onChange: handleFileUpload,
          disabled: __props.previewFiles.length >= _unref(MAX_SAVABLE_FILES_COUNT)
        }, null, 40, _hoisted_2))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.previewFiles, (file) => {
        return (_openBlock(), _createElementBlock("div", {
          key: file.id,
          class: "file-box"
        }, [
          (_unref(isImageFileType)(file.path))
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("img", {
                  src: file.content,
                  class: "image"
                }, null, 8, _hoisted_4),
                (__props.isChangeable)
                  ? (_openBlock(), _createElementBlock("i", {
                      key: 0,
                      class: "fa fa-times-circle remove-image-btn",
                      onClick: ($event: any) => (removeFile(file.id))
                    }, null, 8, _hoisted_5))
                  : _createCommentVNode("", true)
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createElementVNode("i", {
                  class: _normalizeClass(["far fa-3x", _unref(fileTypeIconFromFilePath)(file.path)])
                }, null, 2),
                (__props.isChangeable)
                  ? (_openBlock(), _createElementBlock("i", {
                      key: 0,
                      class: "fa fa-times-circle remove-file-btn",
                      onClick: ($event: any) => (removeFile(file.id))
                    }, null, 8, _hoisted_6))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_7, _toDisplayString(file.name), 1)
              ], 64))
        ]))
      }), 128))
    ])
  ]))
}
}

})